import { useContext, useEffect, useRef, useState } from 'react';
import { GoogleAnalyticsContext } from '../../GoogleAnalytics';
import { Input } from '../../Input/Input';
import Stepper, { useStepper } from '../../Stepper';
import FormatDate from '../../Util/FormatDate';
import eta from '../assets/eta.png';
import SameDayArrivalModal from './SameDayArrivalModal';

export function EtaPortPage() {
  const { stepBackward, localData, setDataByKey, activeStepKey, gotoStep } = useStepper();
  const [sameDayModalOpen, setSameDayModalOpen] = useState(false);

  const isImportArrival = localData.movementType !== 'Export';

  const proceedAfterArrivalDateValidated = () => {
    if (localData.confirmedNoCG == 'NCG') {
      gotoStep('10. Commercial Documents');
    }
    if (localData.confirmedNoCG == 'CG') {
      gotoStep('9. Documents');
    }
  };

  const nextPage = () => {
    if (!localData.date) {
      setError('Please enter a loading date.');
      return;
    }
    const dSelected = new Date(localData.date);
    dSelected.setHours(0, 0, 0, 0);
    const dNow = new Date();
    dNow.setHours(0, 0, 0, 0);
    if (dSelected < dNow) {
      setError('Date must be in the future.');
      return;
    }
    const todaysDate = new Date().toISOString().slice(0, 10);
    if (isImportArrival && localData.date === todaysDate) {
      setSameDayModalOpen(true);
      return;
    }
    proceedAfterArrivalDateValidated();
  };

  const handleSameDayConfirm = () => {
    setSameDayModalOpen(false);
    proceedAfterArrivalDateValidated();
  };

  const handleSameDayCancel = () => {
    setDataByKey('date', '');
    setSameDayModalOpen(false);
  };

  const backwards = () => {
    setError('');
    stepBackward();
  };

  const isInitialized = useRef(false);
  const ga = useContext(GoogleAnalyticsContext);

  useEffect(() => {
    if (ga.gaInitialized) {
      if (activeStepKey === '7. EtaPort' && isInitialized.current === false) {
        isInitialized.current = true;
        window?.gtag?.('event', '7. EtaPort', {
          event_category: 'EPO',
        });
      }
    }
  }, [activeStepKey, ga.gaInitialized]);

  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
  }, [localData.date]);

  return (
    <Stepper.Step hideUnlessVisited stepKey="7. EtaPort" text="Date of Arrival">
      <SameDayArrivalModal
        show={sameDayModalOpen}
        onCancel={handleSameDayCancel}
        onConfirm={handleSameDayConfirm}
        arrivalDateUk={localData.date ? FormatDate(localData.date) : ''}
      />

      <div className="mb-3 themed-text" style={{ fontSize: '1.8rem' }}>
        Date of Arrival
      </div>
      <div className="themed-text">
        <label
          className="d-inline-flex align-items-center gap-2 mb-2"
          style={{ marginBottom: '10px', marginRight: '86px' }}
        >
          <input type="radio" disabled checked={localData.movementType === 'Import'} />
          <span>Import</span>
        </label>

        <label className="d-inline-flex align-items-center gap-2" style={{ marginBottom: '10px' }}>
          <input type="radio" disabled checked={localData.movementType === 'Export'} />
          <span>Export</span>
        </label>
      </div>
      <div
        className=" px-2 mt-1 pt-2 d-flex flex-column"
        style={{ borderRadius: '0.9rem', background: 'rgba(255, 255, 255)', minHeight: '485px' }}
      >
        <div className="d-flex step-banner justify-content-center">
          <img src={eta} width="150" height="150" alt="port" className="mt-4 mb-4" />
        </div>

        <div className="d-flex align-self-center flex-column mt-auto  px-4" style={{ maxWidth: '400px' }}>
          <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
            Select Arrival date for this shipment.{' '}
          </span>
          <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
            Date changes can be made with the
          </span>

          <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
            calendar tool on the status screen.
          </span>
        </div>

        <div className=" d-flex flex-column mt-auto" style={{ paddingLeft: '6rem', paddingRight: '6rem' }}>
          <Input
            label="Shipment date of Arrival"
            name="dateOfArrival"
            type="date"
            min={new Date().toISOString().slice(0, 10)}
            value={localData.date}
            required
            data-testid="shipmentArrival-datePicker"
            onChange={(e) => setDataByKey('date', e.target.value)}
          />
        </div>
        <div className="px-3 mb-3 w-75 mx-auto">
          {error && (
            <div className="alert-danger px-3 py-1 w-100 text-center" style={{ borderRadius: '10px' }}>
              {error}
            </div>
          )}
        </div>

        <section className="d-flex justify-content-between px-3 pb-4 mt-auto">
          <button type="button" className="stepper-button red" onClick={backwards}>
            Back
          </button>
          <button type="button" className="stepper-button" onClick={nextPage}>
            Next
          </button>
        </section>
      </div>
    </Stepper.Step>
  );
}
